module.exports = __webpack_public_path__ + "static/media/Caterina_Esposito_Pic.2cbe556c.jpeg";